// Nav scroll state
  const nav = document.getElementById('nav');
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 40);
  });

  // Mobile nav toggle
  const navToggle = document.getElementById('navToggle');
  const navLinks = document.getElementById('navLinks');
  navToggle.addEventListener('click', () => {
    navToggle.classList.toggle('open');
    navLinks.classList.toggle('open');
  });
  navLinks.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
    navToggle.classList.remove('open');
    navLinks.classList.remove('open');
  }));

  // Scroll reveal
  const revealEls = document.querySelectorAll('.reveal, .card');
  revealEls.forEach(el => el.classList.add('__observed'));
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  revealEls.forEach(el => io.observe(el));

  // Stagger product cards
  document.querySelectorAll('#productGrid .card').forEach((card, i) => {
    card.style.transitionDelay = (i * 90) + 'ms';
  });

  // Carousel drag + buttons
  const carousel = document.getElementById('carousel');
  let isDown = false, startX, scrollLeft;

  carousel.addEventListener('mousedown', (e) => {
    isDown = true;
    carousel.classList.add('dragging');
    startX = e.pageX - carousel.offsetLeft;
    scrollLeft = carousel.scrollLeft;
  });
  ['mouseleave','mouseup'].forEach(evt => carousel.addEventListener(evt, () => {
    isDown = false;
    carousel.classList.remove('dragging');
  }));
  carousel.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - carousel.offsetLeft;
    const walk = (x - startX) * 1.4;
    carousel.scrollLeft = scrollLeft - walk;
  });

  const scrollAmount = () => carousel.querySelector('.carousel-item').offsetWidth + 22;
  document.getElementById('carNext').addEventListener('click', () => {
    carousel.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
  });
  document.getElementById('carPrev').addEventListener('click', () => {
    carousel.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
  });
